import assets, { getDay } from "../assets";

export const CongressBackInTime = {
    height: "25.2%",
    onClick() {
        window.open(assets.global.CongressBackInTime)
    },
    label: "Congress Back in time",
    left: "78.5%",
    top: "67.6%",
    width: "7.9%",
}

export default function () {

    const day = getDay()

    return {
        background: assets.on_demand.df,
        showNavbar: day > 0,
        name: "on-demand",
        links: [
            {
                height: "34.2%",
                href: day > 0 ? "/breakouts" : undefined,
                label: "Breakouts",
                left: "84.5%",
                top: "35.6%",
                width: "13.9%",
                modalOverrides: {
                    dismissHTML: "X"
                },
                modal: day === 0 ? <div style="display: flex; flex-direction: column; justify-content: space-around; width: 600px; height: 130px; color: white;">
                    <h1 style="font-size: 28px; margin: 0;">Content locked</h1>
                    <p style="font-size: 16px;">
                        <p>On Demand Breakouts sessions will be available starting October 27th</p>
                    </p>
                </div> : undefined
            },
            {
                height: "34.2%",
                href: day >= 1 ? "/keynotes" : undefined,
                label: "Keynotes",
                left: "2.5%",
                top: "35.6%",
                width: "13.9%",
                modalOverrides: {
                    dismissHTML: "X"
                },
                modal: day === 0 ? <div style="display: flex; flex-direction: column; justify-content: space-around; width: 600px; height: 130px; color: white;">
                    <h1 style="font-size: 28px; margin: 0;">Content locked</h1>
                    <p style="font-size: 16px;">
                        <p>On Demand Keynotes sessions will be available starting October 27th</p>
                    </p>
                </div> : undefined
            },
            {
                height: "34.2%",
                href: day >= 1 ? "/interviews" : undefined,
                label: "interviews",
                left: "42.5%",
                top: "35.6%",
                width: "13.9%",
                modalOverrides: {
                    dismissHTML: "X"
                },
                modal: day === 0 ? <div style="display: flex; flex-direction: column; justify-content: space-around; width: 600px; height: 130px; color: white;">
                    <h1 style="font-size: 28px; margin: 0;">Content locked</h1>
                    <p style="font-size: 16px;">
                        <p>On Demand Studio Interviews sessions will be available starting October 27th</p>
                    </p>
                </div> : undefined
            },
            CongressBackInTime
        ]
    }
}